import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';

const BillPrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '700px',
        height: '700px',
    };

    const printStyles = `
        @media print {
            body {
                margin: 10px;
            }
        }
    `;

    if (!labelData || labelData.length === 0) {
        return null;
    }

    const firstItem = labelData[0];

    // const NumberToWords = (num) => {
    //     const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    //     const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    //     const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    //     const convert = (num) => {
    //         if (num < 10) return units[num];
    //         if (num < 20) return teens[num - 11];
    //         if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
    //         if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100);
    //         if (num < 10000) return units[Math.floor(num / 1000)] + ' Thousand ' + convert(num % 1000);
    //         return 'Number is too large';
    //     };

    //     if (num === 0) return 'Zero';
    //     return convert(num);
    // };

    // const AmountInWords = ({ amount }) => {
    //     const formattedAmount = parseFloat(amount).toFixed(2);
    //     const [rupees, decimal] = formattedAmount.split('.');

    //     return (
    //         <div>
    //             <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
    //             {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
    //         </div>
    //     );
    // };
    const NumberToWords = (num) => {
        

        const belowTwenty = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const thousands = ["", "Thousand", "Lakh", "Crore"];

        const convert = (n) => {
            if (n === 0) return "";
            if (n < 20) return belowTwenty[n] + " ";
            if (n < 100) return tens[Math.floor(n / 10)] + " " + belowTwenty[n % 10] + " ";
            if (n < 1000) return belowTwenty[Math.floor(n / 100)] + " Hundred " + convert(n % 100);
            for (let i = 0, divisor = 1000; i < thousands.length; i++, divisor *= 100) {
                if (n < divisor * 100) {
                    return convert(Math.floor(n / divisor)) + thousands[i] + " " + convert(n % divisor);
                }
            }
        };

        return convert(num).trim();
    };

    const AmountInWords = ({ amount }) => {
        // Ensure the amount is valid and convert it to a float
        const cleanedAmount = parseFloat(amount || 0).toFixed(2);
        const [rupees, decimal = "00"] = cleanedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && (
                    <p>{NumberToWords(parseInt(decimal))} Paise Only</p>
                )}
            </div>
        );
    };

    return (
        <div style={{ ...containerStyle, padding: '20px' }}>
            <style>{printStyles}</style>
            {firstItem && firstItem.ReceiptPrint && (
                <div>
                    <h1 style={{ textAlign: 'center', marginBottom: '10px', color: 'blue', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontWeight: 'bold' }}>
                        {firstItem.ReceiptPrint.CompanyName}
                    </h1>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '-20px' }}>
                        <PlaceIcon style={{ color: 'green', width: '30px', height: '30px' }} />
                        <h3 style={{ marginLeft: '10px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontWeight: 'bolder', fontSize: '16px' }}>
                            {firstItem.ReceiptPrint.Address} Pin: {firstItem.ReceiptPrint.Pincode}
                        </h3>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '-20px' }}>
                        <PhoneIcon style={{ color: 'blue', width: '30px', height: '30px' }} />
                        <h3 style={{ marginLeft: '10px', color: 'black', fontWeight: 'bolder' }}>
                            {firstItem.ReceiptPrint.CompanyContactNumber}, {firstItem.ReceiptPrint.CompanyContactNumber2}
                        </h3>
                    </div>

                    <h3 style={{ marginLeft: '10px',textAlign: 'center', marginTop: '-20px', fontWeight: 'bolder', fontSize: '18px' }}>
                        GST NO: {firstItem.ReceiptPrint.GSTNumber}
                    </h3>

                    <hr style={{ border: 'none', borderTop: '1px solid black', margin: '20px -20px', width: 'calc(100% + 40px)' }} />

                    <h2 style={{ textAlign: 'center', marginBottom: '10px', fontSize: '20px', fontWeight: 'bold' }}>
                       Receipt
                    </h2>

                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Customer: {firstItem.ReceiptPrint.Name}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Phone No: {firstItem.ReceiptPrint.ContactNumber}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Address: {firstItem.ReceiptPrint.AddressLine1}</strong>
                    </div>
                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Receipt No: {firstItem.ReceiptPrint.ReceiptNo}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '16px' }}>
                        <strong style={{ fontSize: '20px' }}>Receipt Date: {new Date(firstItem.ReceiptPrint.ReceiptDate).toLocaleDateString('en-GB')}</strong>
                    </div>
                </div>
            )}

            {firstItem && firstItem.ReceiptPrint && (
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Remarks</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Bill Amount</th>
                           
                            <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Paid Amount</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Advance Amount</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>pending Amount</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Payment Mode</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.Receiptremarks}</td>
                            <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.BillAmount}</td>

                            <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.TotalAmount}</td>
                            {/* <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.AdvanceAmount}</td> */}
                            <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.AdvancedAmount || 0}</td>
                            <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.BalanceAmount}</td>
                            <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{firstItem.ReceiptPrint.Paymenttype}</td>
                        </tr>
                    </tbody>
                </table>
            )}

            {firstItem && firstItem.ReceiptPrint && (
                <AmountInWords amount={firstItem.ReceiptPrint.TotalAmount} />
            )}
        </div>
    );
};

export default BillPrint;
